import React from 'react';

import flattenDeep from 'lodash/flattenDeep';

import { loadAudienceActionsLog } from 'scenes/CustomAudiences/Audiences/sources/audiences';
import ActionsLog from 'scenes/CustomAudiences/components/ActionsLog';
import { useLoadLogs } from 'scenes/CustomAudiences/components/ActionsLog/useLoadLogs';

export default ({ id }) => {
  const { data, hasNextPage, fetchNextPage, isFetching, isLoading } =
    useLoadLogs(id, loadAudienceActionsLog);

  return (
    <ActionsLog
      logs={flattenDeep(data?.pages)}
      isFetching={isFetching}
      isLoading={isLoading}
      onRowsScrollEnd={() => {
        return hasNextPage && fetchNextPage();
      }}
    />
  );
};
